module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc11-45effc267df3c287df9c7f38dd06a18b.jpg";